import React from "react";
import { Box, Image, SimpleGrid } from "@chakra-ui/react";
import Section from "./Section";
import { galleryImages } from "../data/content";

export default function Gallery() {
  return (
    <Section
      id="gallery"
      title="Gallery"
      subtitle="A look at the products and installations we deliver."
    >
      <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} spacing={5}>
        {galleryImages.map((image, idx) => (
          <Box
            key={image.src}
            borderRadius="xl"
            overflow="hidden"
            border="1px solid"
            borderColor="ink.100"
            bg="ink.50"
          >
            <Image
              src={`${process.env.PUBLIC_URL}/${image.src}`}
              alt={image.alt}
              // First row is above the fold on most screens; the rest can wait.
              loading={idx < 3 ? "eager" : "lazy"}
              objectFit="cover"
              w="100%"
              h={{ base: "220px", md: "240px" }}
              transition="transform 0.4s ease"
              _hover={{ transform: "scale(1.04)" }}
            />
          </Box>
        ))}
      </SimpleGrid>
    </Section>
  );
}
